import React from 'react';
import InviteOperatorModal from './InviteOperatorModal';
import useTranslation from 'hooks/useTranslation';
import { HeaderSectionIcon } from 'components';

const OperatorsHeader = () => {
  const { getTranslation } = useTranslation('OPERATORS');
  const { t } = getTranslation();

  return (
    <div className='flex flex-jc-sb flex-ai-s Operators-Header'>
      <div className='operators__header__title flex flex-colgap-8'>
        <HeaderSectionIcon />

        <div>
          <h1 className='main_section_header_title'>{t('HEADING_TITLE')}</h1>
          <p className='operators__header__title__subtext main_section_header_desc'>
            {t('HEADING_SUBTITLE')}
          </p>
        </div>
      </div>
      <div className='operators__header__actions'>
        <InviteOperatorModal />
      </div>
    </div>
  );
};

export default OperatorsHeader;
